import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './axios.config.js';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbartop from './Components/Navbar/Navbartop';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Accueil from './Components/Accueil/Accueil';
import Login from './Components/Login/Login';
import Administration from './Components/Administration/Administration';
import React, {useEffect, useContext} from 'react';
import {MadricContext} from './Context/MadricContext';
import Chantier from './Components/Chantier/Chantier';
import ChantierInfo from './Components/ChantierInfo/ChantierInfoBase/ChantierInfo';
import Checkin from './Components/Checkin/CheckinList/Checkin';
import CheckinInfo from './Components/Checkin/CheckinUpdate/CheckinInfo';
import AddCheckinInfo from './Components/Checkin/AddCheckinInfo/AddCheckinInfo';
import ChantierUpdate from './Components/Chantier/ChantierUpdate/ChantierUpdate';
import UpdatePhoto from './Components/Media/UpdateMedia/UpdatePhoto/Updatephoto';
import AddPhoto from './Components/Media/AddMedia/AddPhoto/AddPhoto';
import AddFacture from './Components/Media/AddMedia/AddFacture/AddFacture';
import AddFile from './Components/Media/AddMedia/AddFile/AddFile';
import UpdateFile from './Components/Media/UpdateMedia/UpdateFile/UpdateFile';
import AddNote from './Components/Media/AddMedia/AddNote/AddNote';
import UpdateNote from './Components/Media/UpdateMedia/UpdateNote/UpdateNote';
import UpdateTodolistHistorique from './Components/Media/UpdateMedia/UpdateTodolistHistorique/UpdateTodolistHistorique.js';
import InfoGlobalBase from './Components/InfoGlobal/InfoGlobalBase/InfoGlobalBase.js';
import './App.css';

/**
 * App principal
 * @return {JSX}
 */
function App() {
  const {setConnUser} = useContext(MadricContext);

  useEffect(() => {
    const storedAccessToken = localStorage.getItem('accessToken');
    if (storedAccessToken !== null) {
      const storedConnUser = localStorage.getItem('connUser');
      if (storedConnUser !== null) {
        setConnUser(JSON.parse(storedConnUser));
      }
    }
  }, []);

  return (
    <div className="body">
      <Router>
        <Navbartop />
        <Routes>
          <Route exact path="/" element={<Accueil />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/administration" element={<Administration />} />
          <Route exact path="/updateChantier" element={<ChantierUpdate />} />
          <Route exact path="/chantier" element={<Chantier />} />
          <Route exact path="/chantier/:id" element={<ChantierInfo />} />
          <Route exact path="/Checkin" element={<Checkin />} />
          <Route exact path="/Checkin/:id" element={<CheckinInfo />} />
          <Route exact path="/AddCheckin" element={<AddCheckinInfo />} />
          <Route exact path="/AddPhoto" element={<AddPhoto />} />
          <Route exact path="/AddFacture" element={<AddFacture />} />
          <Route exact path="/UpdatePhoto" element={<UpdatePhoto />} />
          <Route exact path="/AddFile" element={<AddFile />} />
          <Route exact path="/UpdateFile" element={<UpdateFile />} />
          <Route exact path="/AddNote" element={<AddNote />} />
          <Route exact path="/UpdateNote" element={<UpdateNote />} />
          <Route exact path="/UpdateTodolist" element={<UpdateTodolistHistorique />} />
          <Route exact path="/InfoGlobal" element={<InfoGlobalBase />}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
